export default __webpack_public_path__ + "static/media/icons8-javascript.afe99d35.svg";